import React from 'react'
import FormProduct from '../../../../../../assets/css/components/admin/marketplace-to-marketplace/products/FormProduct'
import { Text } from '../../../../../../assets/css/components/admin/marketplace-to-marketplace/modals/ModalSelectStoreAndSection';
export default function ViewProductsAfterToPost({ isLoad, data }) {
  console.log('data', data);
  const errors = data.data?.errorProducts || [];
  const goods = data.data?.successProducts || [];
  return (
    <FormProduct.Contform>
      <FormProduct.HeaderContForm>
        <Text size="13pt" fw="500" cl="#FFFFFF">
          {
            isLoad ?
            'Proceso Finalizado' : 'Cargando...'
          }
          
        </Text>
      </FormProduct.HeaderContForm>
      <FormProduct.BodyContForm>
        <FormProduct.ContInputAndLabel>
          <Text size="14pt" fw="500">
            Total de productos Publicados
          </Text>
          <Text size="12pt" fw="500">
            {
              isLoad ?
              goods?.length
              :
              'Cargando'
            }
          </Text>
        </FormProduct.ContInputAndLabel>
        <FormProduct.ContInputAndLabel>
          <Text size="14pt" fw="500">
            Total de productos con errores
          </Text>
          <Text size="12pt" fw="500">
            {
              isLoad ?
                errors?.length
                : 'Cargando'
          }
          </Text>
        </FormProduct.ContInputAndLabel>
        {
          (errors?.length > 0) &&
          errors.map((v, i) => {
            return (
              <FormProduct.ContInputAndLabel b="1px solid #a2abbd" key={i} mb="10px">
                <Text size="12pt" fw="500">
                  ID: {v.fatherId}
                </Text>
                <Text size="12pt" fw="500">
                  Title: {v.fatherTitle}
                </Text>
                <Text size="12pt" fw="500">
                  Error: {v?.error?.type}
                </Text>
              </FormProduct.ContInputAndLabel>
            )
          })
        }
      </FormProduct.BodyContForm>
    </FormProduct.Contform>
  )
}
